import getLocationByZip from '../../core/get-location-by-zip';
import getCompanyLogos from '../../core/get-company-logos';

// @private
// @see https://github.com/healthcarecom/sem-content#sites-short-names
const mapSiteName = (site) => {
  site = site.toLowerCase();
  if (site.indexOf('www.healthcare.com') > -1) return 'HC';
  if (site.indexOf('www.healthcare.org') > -1) return 'ORG';
  if (site.indexOf('quotes.healthcare.com') > -1) return 'HEALTH';
  if (site.indexOf('quotes.healthcare.org') > -1) return 'HEALTH_ORG';
  if (site.indexOf('mobile.healthcare.com') > -1) return 'HEALTH_M';
  if (site.indexOf('www.medicareguide.com') > -1) return 'MG';
  if (site.indexOf('medicare.healthcare.com') > -1) return 'MEDICARE';
  if (site.indexOf('m.medicare.healthcare.com') > -1) return 'MEDICARE_M';
  if (site.indexOf('www.medicareguide.com/supplement') > -1) return 'MED_SUP';
  if (site.indexOf('www.medicareguide.com/part-c') > -1) return 'MED_ADV';
  if (site.indexOf('www.medicareguide.com/part-d') > -1) return 'MED_PDP';
  return site.toUpperCase();
};

/**
 * @public
 * Gets logos of the carriers by site.
 *
 * @param  {Object} options - parameters to send: `{siteName, stateAcronym, zipcode}`
 * @return {Promise}
 */
export default function getLogosBySite({ siteName, stateAcronym, zipcode }) {
  siteName = mapSiteName(siteName);
  const data = { siteName, stateAcronym };
  let promise = Promise.resolve(data);

  if (!stateAcronym) {
    promise = getLocationByZip(zipcode)
      .then((geoInfo) => {
        data.stateAcronym = geoInfo.stateAcronym;

        return data;
      });
  }

  return promise
    .then(getCompanyLogos)
    .then(res => res.data);
}
